import React, {useState, useEffect} from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import {Container, Row, Col} from 'reactstrap';
import TextInput from '../TextInput/TextInput';
import {getRecaptchaToken} from '../../../utilities/recaptcha/recaptcha';
import {showAppLoader, hideAppLoader} from '../Loader/LoaderSlice';
import BtnSubmit from '../Buttons/BtnSubmit';
import {validateFields, validateField} from '../../../utilities/validation/validator';
import {connect} from 'react-redux';
import ProviderManager from './../../../provider/providerManager';

const OtpPhone = (props) => {
  const [form, setForm] = useState({
    phone: '',
    id: '',
    errors: {
      phone: '',
    },
  });

  useEffect(() => {}, []);

  const getTicket = async () => {
    if (validateForm(form)) {
      const step1Ticket = await createOtpStep1();
      if (step1Ticket && step1Ticket != '') {
        props.onTicket({ticketId: step1Ticket, phoneNumber: form.phone, idNumber: form.id});
      }
    }
  };

  async function createOtpStep1() {
    const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');

    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    props.showAppLoader();
    try {
      const result = await ProviderManager.getProviderData('createOtp', [form.phone, null, captchaToken]);
      if (result.Body && result.Body.step1Ticket) {
        return result.Body.step1Ticket;
      }
    } catch (error) {
      console.info('createOtp', error);
      return null;
    } finally {
      props.hideAppLoader();
    }
  }

  const clearIsValid = () => {
    form.valid = false;
    setForm(form);
  };

  const clearPhone = () => {
    form.phone = '';
    setForm(form);
  };

  const validateForm = (e) => {
    const form = Object.assign({}, validateFields(e));
    setForm(form);
    if (!props.isDisplayIdentity && form.errors.id != '' && form.errors.phone == '') {
      return true;
    }

    return false;
  };

  const changeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    const tmpForm = Object.assign({}, validateField(form, name, value));

    if (tmpForm.phone.length > 10) {
      tmpForm.phone = tmpForm.phone.slice(0, 10);
      tmpForm.errors.phone = '';
    }

    let isNumber = /^\d+$/.test(form.phone);

    if (tmpForm.phone.length < 10 && isNumber) tmpForm.errors.phone = '';

    setForm(tmpForm);
  };

  return (
    <div className='shared-otp-phone'>
      <div className='content'>
        <Row>
          <Col ms={12}>
            <h1 className='title-small'>{props.title}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <h2 className='title-big'>{props.subTitle}</h2>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <p className='title-small'>{props.linkText}</p>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <div className='component-container'>
              {props.topComment && <div className='comment'>{props.topComment}</div>}
              <TextInput
                name='phone'
                type='number'
                pattern='[0-9]*'
                id='phone'
                maxLength='10'
                autoComplete='off'
                placeholder={props.placeholder ?? 'טלפון'}
                required='required'
                value={form.phone}
                error={form.errors.phone}
                // onBlur={(e) => blurHandler({ target: e.target, form: form })}
                onChange={(e) => changeHandler({target: e.target, form: form})}
              />
              {props.bottomComment && <div className='comment'>{props.bottomComment}</div>}
              {props.isDisplayIdentity && (
                <TextInput
                  error={form.errors.id}
                  onChange={(e) => changeHandler({target: e.target, form: form})}
                  value={form.id}
                  name='id'
                  maxLength='9'
                  pattern='[0-9]*'
                  type='number'
                  placeholder='תעודת זהות'
                  required='required'
                />
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div style={{textAlign: 'center'}}>
              <BtnSubmit onclick={getTicket} text={props.buttonText} />
            </div>
          </Col>
        </Row>
        {props.bottomLink != undefined && props.bottomText != '' && (
          <Row>
            <Col ms={12}>
              <br />
              <p className='bottom-text'>{props.bottomText}</p>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.otpVerifyCode.form,
  };
};

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpPhone);
